import { useTranslations } from '@ifixit/i18n';
import { SSOButton } from './SSOButton';
import { GoogleSSOButton } from './GoogleSSOButton';
import { FacebookSSOButton } from './FacebookSSOButton';
import { AppleSSOButton } from './AppleSSOButton';
import { FormError } from './FormError';

export function SSOLoginButtons({
   loginHandler,
   error,
   setError,
   register,
}: {
   loginHandler: (response: any) => void;
   error: string | null;
   setError: (error: string) => void;
   register?: boolean;
}) {
   const t = useTranslations('Login');
   if (
      !(
         App.ssoLoginUrl ||
         App.googleLoginEnabled ||
         App.facebookLoginEnabled ||
         App.appleLoginEnabled
      )
   ) {
      return null;
   }

   return (
      <>
         <div className="flex flex-col gap-3 w-full">
            {App.ssoLoginUrl && (
               <SSOButton
                  href={App.ssoLoginUrl}
                  text={register ? t('signUpWithSSO') : t('signInWithSSO')}
               />
            )}
            {App.googleLoginEnabled && (
               <GoogleSSOButton
                  setError={setError}
                  loginHandler={loginHandler}
                  text={register ? t('signUpWithGoogle') : t('signInWithGoogle')}
               />
            )}
            <AppleSSOButton
               setError={setError}
               loginHandler={loginHandler}
               text={register ? t('signUpWithApple') : t('signInWithApple')}
            />
            <FacebookSSOButton
               setError={setError}
               loginHandler={loginHandler}
               text={register ? t('signUpWithFacebook') : t('signInWithFacebook')}
            />
            <FormError>{error}</FormError>
         </div>
         <div className="flex items-center justify-center h-5 relative w-full before:content-[''] before:absolute before:top-1/2 before:-translate-y-1/2 before:w-full before:h-px before:bg-gray-300 before:border-b before:border-gray-300 before:z-0">
            <span className="bg-white inline-flex mx-auto text-sm h-inherit px-6 relative uppercase">
               {t('or')}
            </span>
         </div>
      </>
   );
}
